import { Delete } from '@mui/icons-material'
import { Button, Tooltip } from '@mui/material'
import { useRecycleMedia } from '../hooks/useRecycleMedia'
import type { PreviewButtonProps } from './Buttons'

export const RecycleButton = (props: PreviewButtonProps) => {
  const { searchResultItem, visible } = props
  const { handleRecycleMedia } = useRecycleMedia()

  if (!visible) return null

  return (
    <Tooltip title="Recycle Media" placement="top">
      <Button
        color="error"
        onClick={() => handleRecycleMedia(searchResultItem)}
      >
        <Delete />
      </Button>
    </Tooltip>
  )
}
